import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="check-all"
export default class extends Controller {
  static values = { max: Number }
  static targets = ["item"]

  connect() {
  }

  checkAll(event) {
    const checkState = event.target.checked;

    this.itemTargets.forEach((item) => {
      if (checkState === false) {
        item.checked = false;
        return;
      }

      if (this.checkedCount() < this.maxValue) {
        item.checked = true;
      }
    });
  }

  checkItem(event) {
    if (this.checkedCount() > this.maxValue) {
      event.target.checked = false;
      alert(`Нельзя выбрать больше ${this.maxValue} протоколов`);
    }

  }

  checkedCount() {
    return Array.from(this.itemTargets).filter(i => i.checked).length
  }
}
